import { useEffect } from 'react';

export const useStepperNavigation = ({
  currentStep,
  steps,
  handleClick,
  handleSubmit,
  disable,
}) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Ignore shortcuts if the user is typing in an input field
      const isTyping = 
        ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName) || 
        document.activeElement.isContentEditable;
      
      if (isTyping) return;

      if (event.key === 'Enter') {
        if (!disable) {
          if (currentStep === steps.length) {
            handleSubmit();
          } else {
            handleClick('next');
          }
        }
      }

      if (event.key === 'ArrowLeft') {
        if (currentStep > 1) {
          handleClick('prev');
        }
      }
      if (event.key === 'ArrowRight' && !disable) {
        if (currentStep < steps.length) {
          handleClick('next');
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentStep, steps, handleClick, handleSubmit, disable]);
};

export const useFormKeyboardSubmit = (handleSubmit, disable, loading) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' && !disable && !loading) {
        event.preventDefault();
        handleSubmit();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleSubmit, disable, loading]);
};
